<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <ion-toolbar class="custom-toolbar">
    <div class="toolbar-content">
      <div class="title-group">
        <span class="title-main">Generar Pago</span>
        <span class="title-sub">{{ nombreTrabajador }}</span>
      </div>
      <ion-button class="icon-btn" fill="clear" (click)="cerrar()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="pago-content">
  <div class="content-wrapper">

    <!-- Resumen de Pago -->
    <div class="summary-card glass-card">
      <div class="summary-header">
        <div class="summary-icon-wrap">
          <ion-icon name="wallet-outline"></ion-icon>
        </div>
        <div class="summary-title-group">
          <span class="summary-title">Resumen a Pagar</span>
          <span class="summary-subtitle">{{ pendientes.length }} registro(s) seleccionados</span>
        </div>
      </div>

      <div class="summary-grid">
        <div class="summary-item">
          <span class="label">Monto Base</span>
          <span class="value">{{ montoTotal | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Extras</span>
          <span class="value success">+{{ extrasTotal | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Descuentos</span>
          <span class="value danger">-{{ descuentosTotal | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </div>

      <div class="total-row">
        <span class="total-label">Total a Pagar</span>
        <span class="total-value">{{ totalPagar | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>
    </div>

    <!-- Controles -->
    <div class="section-label">
      <ion-icon name="settings-outline"></ion-icon>
      <span>Configuración del Pago</span>
    </div>

    <div class="controls-container">
      <!-- Fecha de Pago -->
      <div class="input-group full">
        <label><ion-icon name="calendar-outline"></ion-icon> Fecha de Pago</label>
        <div class="premium-input-wrapper date-input">
          <input type="date" [(ngModel)]="fechaPago">
          <ion-icon name="calendar-outline" color="primary" class="date-icon"></ion-icon>
        </div>
      </div>

      <!-- Comentario (Estilo EditActivity) -->
      <div class="input-group full">
        <label><ion-icon name="chatbox-ellipses-outline"></ion-icon> Comentario / Referencia</label>
        
        <div class="template-selector" *ngIf="observationTemplates.length > 0">
          <div class="template-chips-scroll">
            <ion-chip class="template-chip clear-chip" *ngIf="comentario" (click)="applyTemplate('clear')">
              <ion-icon name="trash-outline"></ion-icon>
              <ion-label>Limpiar</ion-label>
            </ion-chip>
            <ion-chip class="template-chip"
              [class.active-template]="comentario && comentario.includes(t.texto)"
              *ngFor="let t of observationTemplates" (click)="applyTemplate(t)">
              <ion-label>{{t.titulo}}</ion-label>
            </ion-chip>
          </div>
        </div>

        <div class="premium-input-wrapper">
          <textarea rows="3" [(ngModel)]="comentario"
            placeholder="Escriba un comentario o referencia del pago..."></textarea>
        </div>
      </div>
    </div>

    <!-- Lista de Pendientes -->
    <div class="section-label" style="display: flex; align-items: center; width: 100%;">
      <ion-icon name="list-outline"></ion-icon>
      <span>Registros {{ isEdit && !mostrarPendientes ? 'Pagados' : 'Pendientes' }} ({{ gruposVisibles.length }})</span>
      
      <div style="display: flex; gap: 15px; margin-left: auto; align-items: center;">
        @if (isEdit) {
          <div style="display: flex; align-items: center; gap: 4px; background: rgba(var(--ion-color-primary-rgb), 0.1); padding: 4px 8px; border-radius: 20px;">
            <span style="font-size: 11px; font-weight: 600; color: var(--ion-color-primary); letter-spacing: 0.5px;">+ PENDIENTES</span>
            <ion-toggle [(ngModel)]="mostrarPendientes" mode="ios" style="transform: scale(0.7); margin: 0; padding: 0; width: 36px; height: 24px;"></ion-toggle>
          </div>
        }
        <div class="select-all-wrap" style="margin-left: 0;">
          <span class="select-all-text">Todos</span>
          <ion-checkbox (ionChange)="toggleTodos($event)" [checked]="true" color="primary"
            class="premium-checkbox"></ion-checkbox>
        </div>
      </div>
    </div>

    @if (gruposVisibles.length === 0) {
    <div class="empty-state glass-card">
      <div class="empty-icon-wrap">
        <ion-icon name="checkmark-done-circle-outline"></ion-icon>
      </div>
      <h3>¡Al día!</h3>
      <p>No hay registros pendientes de pago para este trabajador.</p>
    </div>
    } @else {
    <div class="pendientes-list">
      @for (grupo of gruposVisibles; track grupo.idGrupo) {
      <div class="grupo-card glass-card" [class.grupo-unificado]="grupo.unificado && grupo.puedeUnificar">
        
        <!-- Cabecera del Grupo -->
        <div class="grupo-header" (click)="toggleGrupo(grupo, null)">
          <ion-checkbox [(ngModel)]="grupo.seleccionado" (ionChange)="toggleGrupo(grupo, $event)" 
            (click)="$event.stopPropagation()" class="premium-checkbox"></ion-checkbox>
          <div class="grupo-title">
            @if (grupo.esSubcontrato) {
              <div class="header-row">
                <span class="grupo-fecha">{{ grupo.items[0]?.lugar }}</span>
                <span class="turno-badge subcontrato-header-badge">
                  <ion-icon name="briefcase-outline"></ion-icon>
                  Subcontrato
                </span>
              </div>
              @if (grupo.descripcionSubcontrato) {
                <span class="grupo-subdescripcion">
                  {{ grupo.descripcionSubcontrato }}
                </span>
              }
            } @else {
              <div class="header-row">
                <span class="grupo-fecha">{{ grupo.fecha | date:'EEEE, dd MMM yyyy' }}</span>
                <span class="turno-badge" [class.nocturno]="grupo.turno === 'N'">
                  <ion-icon [name]="grupo.turno === 'D' ? 'sunny-outline' : 'moon-outline'"></ion-icon>
                  {{ grupo.turno === 'D' ? 'Día' : 'Noche' }}
                </span>
              </div>
            }
          </div>
        </div>

        <!-- Detalle General de Subcontrato -->
        @if (grupo.esSubcontrato) {
        <div class="subcontrato-consolidado">
          <div class="consolidado-row">
            <span>TOTAL ACORDADO:</span>
            <span class="val-base">{{ grupo.subcontratoMonto | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          @if (grupo.subcontratoExtra && grupo.subcontratoExtra > 0) {
          <div class="consolidado-row">
            <span>EXTRAS:</span>
            <span class="val-extra">+{{ grupo.subcontratoExtra | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          <div class="consolidado-row subtotal-row">
            <span>TOTAL + EXTRAS:</span>
            <span class="val-base">{{ grupo.subcontratoMontoConExtra | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          }
          <div class="consolidado-row">
            <span>ADELANTOS / ABONOS:</span>
            <span class="val-descuento">-{{ grupo.subcontratoDescuento | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          <div class="consolidado-row saldo-row">
            <span>SALDO RESTANTE:</span>
            <span class="val-saldo">{{ grupo.subcontratoSaldo | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </div>
        }

        <!-- Opción de Unificar (Solo si hay >1 trabajo en el mismo turno) -->
        @if (grupo.puedeUnificar) {
        <div class="unificar-section">
          <div class="unificar-toggle-wrap">
            <ion-icon name="link-outline" class="unificar-icon"></ion-icon>
            <span class="unificar-label">Unificar Pago del Día</span>
            <ion-toggle [(ngModel)]="grupo.unificado" (ionChange)="cambioMontoUnificado()" mode="ios"></ion-toggle>
          </div>
          
          @if (grupo.unificado) {
          <div class="unificar-input-wrap">
            <span class="ui-label">Monto Único:</span>
            <div class="premium-input-wrapper small-input">
              <span class="currency-symbol">$</span>
              <input type="number" [(ngModel)]="grupo.montoUnificado" (ngModelChange)="cambioMontoUnificado()" placeholder="0.00">
            </div>
          </div>
          }
        </div>
        }

        <!-- Lista de Trabajos dentro del grupo -->
        <div class="grupo-items">
          @for (item of grupo.items; track item.id) {
            @if (!grupo.esSubcontrato || item.extra > 0 || item.descuento > 0) {
            <div class="pendiente-card" [class.selected]="item.seleccionado" [class.no-click]="grupo.esSubcontrato" (click)="!grupo.esSubcontrato && toggleSeleccion(item, grupo)">
              
              <div class="pc-header">
                <!-- Checkbox de selección individual para dividir el pago -->
                @if (!grupo.esSubcontrato) {
                  <ion-checkbox [checked]="item.seleccionado" color="primary" 
                    (click)="$event.stopPropagation()" (ionChange)="toggleSeleccion(item, grupo, $event)" 
                    class="premium-checkbox small-checkbox" style="margin-right: 10px;"></ion-checkbox>
                }
                
                <div class="pc-date-lugar" style="display: flex; align-items: center; gap: 8px; flex: 1;">
                  <span class="lugar">{{ grupo.esSubcontrato ? (item.fecha | date:'dd/MM/yyyy') : item.lugar }}</span>
                  @if (item.subcontrato && !grupo.esSubcontrato) {
                    <span class="subcontrato-badge">Subcontrato</span>
                  }
                </div>
              </div>

              @if (!grupo.esSubcontrato && item.descripcion) {
              <div class="pc-desc">
                <ion-icon name="briefcase-outline"></ion-icon>
                <span>Trabajo: {{ item.descripcion }}</span>
              </div>
              }

              @if (item.comentario) {
              <div class="pc-desc planilla-comment" style="color: var(--ion-color-medium); font-style: italic; margin-top: 4px;">
                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                <span>Actividad: {{ item.comentario }}</span>
              </div>
              }

              @if (grupo.esSubcontrato) {
                <div class="pc-amounts">
                  @if (item.extra > 0) {
                    <div class="amt-item success">
                      <span class="lbl">Extra</span>
                      <span class="val">+{{ item.extra | currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                  @if (item.descuento > 0) {
                    <div class="amt-item danger">
                      <span class="lbl">Adelanto / Abono</span>
                      <span class="val">-{{ item.descuento | currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                </div>
              } @else {
                <div class="pc-amounts" [class.dimmed]="grupo.unificado && grupo.puedeUnificar">
                  <div class="amt-item">
                    <span class="lbl">Base</span>
                    <span class="val" [class.tachado]="grupo.unificado && grupo.puedeUnificar">
                      {{ item.monto | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                  </div>
                  @if (item.extra > 0) {
                  <div class="amt-item success">
                    <span class="lbl">Extra</span>
                    <span class="val">+{{ item.extra | currency:'USD':'symbol':'1.2-2' }}</span>
                  </div>
                  }
                  @if (item.descuento > 0) {
                  <div class="amt-item danger">
                    <span class="lbl">Desc.</span>
                    <span class="val">-{{ item.descuento | currency:'USD':'symbol':'1.2-2' }}</span>
                  </div>
                  }
                  @if (!grupo.unificado) {
                  <div class="amt-item subtotal">
                    <span class="lbl">Subtotal</span>
                    <span class="val">{{ item.subtotal | currency:'USD':'symbol':'1.2-2' }}</span>
                  </div>
                  }
                </div>
              }

              @if (item.comentario) {
              <div class="pc-comentario">
                <ion-icon name="information-circle-outline"></ion-icon>
                <span>{{ item.comentario }}</span>
              </div>
              }
            </div>
            }
          }
        </div>

      </div>
      }
    </div>
    }

    <div class="bottom-spacer"></div>
  </div>
</ion-content>

<ion-footer class="ion-no-border form-footer-actions">
  <!-- Botón Atrás / Cancelar -->
  <ion-button (click)="cerrar()" fill="outline" class="cancel-modal-btn">
    <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
    Atrás
  </ion-button>

  <!-- Botón Siguiente / Guardar (Actualizar o Confirmar Pago) -->
  <ion-button (click)="generarPago()" class="save-btn" [disabled]="pendientes.length === 0 || totalPagar <= 0">
    <span>{{ isEdit ? 'Actualizar Pago' : 'Confirmar Pago' }}</span>
    <ion-icon name="checkmark-done-outline" slot="end"></ion-icon>
  </ion-button>
</ion-footer>